import logoUrl from '@/assets/toecan-logo.svg';
import markUrl from '@/assets/toecan-mark.svg';
import { cx } from '@/lib/cx';
import s from './Logo.module.css';

/**
 * The Toecan lock-up as an <img> (the Illustrator SVG's class names would clash if inlined).
 * Minimum 96 px wide for the full lock-up; the mark alone at least 16 px (style reference §6).
 */
export function Logo({ variant = 'full', className }: { variant?: 'full' | 'mark'; className?: string }) {
  return <img src={variant === 'full' ? logoUrl : markUrl} alt="Toecan" className={cx(variant === 'full' ? s.logo : s.mark, className)} draggable={false} />;
}
